module.exports = __webpack_public_path__ + "img/perpetual-depths.8ce9b2c8.jpg";